import React from "react";
import LegalLayout from "../components/LegalLayout";

const SubprocessorsPage: React.FC = () => (
  <LegalLayout
    title="Subprocessors"
    path="/subprocessors"
    description="The third-party service providers PABS uses to operate the app and website."
    intro="The third-party service providers that help us operate the PABS platform."
  >
        <p>
          Subprocessors are third-party service providers that may process limited information on our behalf to help us
          operate PABS.
        </p>

        <h2>Current subprocessors</h2>
        <ul>
          <li><strong>Hosting</strong>: Hetzner and GoDaddy (servers for the app backend and this website).</li>
          <li><strong>File storage and email</strong>: Amazon Web Services (S3 for photos and receipts, SES for email).</li>
          <li><strong>Sign-in and notifications</strong>: Google Firebase (phone sign-in codes and push notifications), plus Google and Apple sign-in.</li>
          <li><strong>SMS</strong>: Semaphore, Txtbox, and Telnyx (one-time sign-in codes).</li>
          <li><strong>Maps and places</strong>: Mapbox and Google Maps Platform (maps, address search, and routes).</li>
          <li><strong>Advertising</strong>: Google AdMob (ads shown in the app).</li>
          <li><strong>Website analytics and security</strong>: Google Analytics, Google Tag Manager, and Google reCAPTCHA.</li>
          <li><strong>In-app purchases</strong>: Google Play and the Apple App Store (for rider and merchant purchases only).</li>
          <li><strong>Link sharing</strong>: TinyURL (short links for shared pages).</li>
        </ul>

        <h2>Customer payments</h2>
        <p>
          Customer orders are paid in cash to the rider, or by GCash transfer to the PABS GCash account. No card
          processor handles customer payments, and we never ask for card numbers or your GCash login.
        </p>

        <p className="legal-note">
          The specific vendors we use can change over time as we improve the service.
        </p>

        <h2>Related pages</h2>
        <p>
          See our <a href="/privacy">Privacy Statement</a> and <a href="/cookies">Cookies Notice</a>.
        </p>
  </LegalLayout>
);

export default SubprocessorsPage;
